import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function Protected({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-[60vh] grid place-items-center text-ink">
                <div className="h-display text-2xl text-gold animate-pulse">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
    return children;
}
